import { connect } from 'react-redux';
import { compose, withProps, withHandlers } from 'recompose';
import { withRouter } from 'react-router';
import { statusSelector, paymentSelector } from '../selector';
import { FullLoadingPortal } from '../components/loading';
import Shop from '../ShopComponent';
import { onAuthentication } from '../actions';

export const CheckoutLoading = compose(
  withProps(() => ({
    message: 'Wir verarbeiten Ihre Bestellung...',
  })),
  connect(state => {
    const { createOrder, payOrder } = statusSelector([
      'createOrder',
      'payOrder',
    ])(state);

    return {
      isLoading: createOrder === 'fetching' || payOrder === 'fetching',
    };
  })
)(FullLoadingPortal);

export const FetchOrderStatusLoading = compose(
  withProps(() => ({
    message: 'Einen Moment Geduld bitte...',
  })),
  connect(state => {
    const { fetchOrder } = statusSelector(['fetchOrder'])(state);
    const { paymentMethod } = paymentSelector(state);
    return {
      isLoading:
        paymentMethod === 'giropay' &&
        (fetchOrder === 'fetching' || !fetchOrder),
    };
  })
)(FullLoadingPortal);

export const ShopConatiner = compose(
  withRouter,
  connect(
    state => {
      const { auth } = statusSelector('auth')(state);

      return {
        loginRequired: auth === 'loginRequired',
        auth,
      };
    },
    dispatch => {
      return {
        authenticate: history =>
          dispatch(onAuthentication('verification', history)),
      };
    }
  ),
  withHandlers(initialProps => {
    const { history } = initialProps;
    return {
      authenticateUser: props => () => props.authenticate(history),
    };
  })
)(Shop);



// WEBPACK FOOTER //
// ./src/containers/status.js